import { FC } from 'react'
import { Grid } from '@material-ui/core'
import Item from './Items'
import useTranslate from '../../../../i18n/useTranslate'
import { useHistory } from 'react-router-dom'

const Report: FC<any> = ({}) => {
    const translate = useTranslate()
    const history = useHistory()
    let dataList = [
        { title: translate.get('UM.REPORT.REVIEWER'), path: '/reviewer/' },
        { title: translate.get('UM.REPORT.FIRSTTIME'), path: '/firsttime/' },
        { title: translate.get('UM.REPORT.HOLD'), path: '/hold/' },
        { title: translate.get('UM.REPORT.EXPIRED'), path: '/expired/' },
        { title: translate.get('UM.REPORT.CLOSED'), path: '/closed/' },
        { title: translate.get('UM.REPORT.CLOSED_3_YEAR'), path: '/closedDue/' },
        { title: translate.get('UM.REPORT.CERTIFICATE_SUMMARY'), path: '/certificateSummary/' },
        { title: translate.get('UM.REPORT.RISK_PROJECT_SUMMARY'), path: '/riskProjectSummary/' },
        { title: translate.get('UM.REPORT.DELETED_PROJECT'), path: '/deletedProject/' },
    ]
    const onClick = (path: string) => {
        history.push(path)
    }

    return (
        <Grid container>
            {dataList.map((item, index) => {
                return (
                    <Grid item xs={12} md={6} lg={6} key={index}>
                        <Item title={item.title} path={item.path} onClick={onClick} />
                    </Grid>
                )
            })}
        </Grid>
    )
}

export default Report
